import type { PropertiesConfig } from '../config'

import { WebStorage } from './web'

/**
 * Uses {@link window.sessionStorage}
 */
export class SessionStorage<
  // NOTE: this must NOT have any default! If it does, it won't get inferred,
  // which breaks a lot
  const TPropertiesConfig extends PropertiesConfig.Constraint,
> extends WebStorage<TPropertiesConfig> {
  /**
   * Default name for a {@link SessionStorage}. If you have more than one
   * {@link SessionStorage} using the same
   * {@link SessionStorage.constructor.Params.parent}, you should pass
   * {@link SessionStorage.constructor.Params.name} to avoid collisions.
   */
  public static readonly DEFAULT_NAME = 'SessionStorage'

  /**
   * @see {@link window.sessionStorage}
   */
  public readonly storage = window.sessionStorage

  constructor(params: SessionStorage.constructor.Params<TPropertiesConfig>) {
    super({
      ...params,
      name: params.name ?? SessionStorage.DEFAULT_NAME,
    })
  }

  /**
   * Removes browser-session values when their owning feature is destroyed, so
   * a later instance cannot restore state from the disposed feature.
   */
  public override destroy(source: string): void {
    if (this.lifecycle.isDestroyed) {
      return
    }

    super.destroy(source)
    this.clearStoredValues()
  }
}
export namespace SessionStorage {
  export namespace constructor {
    export type Params<TPropertiesConfig extends PropertiesConfig.Constraint> =
      Partial.Semi<WebStorage.constructor.Params<TPropertiesConfig>, 'name'>
  }
}
